import { graphql } from '@graphql/__generated'

export const GET_ORDER_BY_ID = graphql(`
  query GetOrderById($orderId: String!) {
    getOrderById(orderId: $orderId) {
      userId
      eventId
      quantity
      tickets {
        title
        email
        fullName
        discountCode
      }
    }
  }
`)
